export const LOADING_START = 'LOADING_START'
export const LOADING_END = 'LOADING_END'

export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE'

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const CHANGE_DONATIONS_TYPE = 'CHANGE_DONATIONS_TYPE'
export const CHANGE_DONATIONS_AMOUNT = 'CHANGE_DONATIONS_AMOUNT'
export const LOGOUT = 'LOGOUT'

export const WS_CONNECTED = 'WS_CONNECTED'
export const WS_ADD_REQUEST_TYPE = 'WS_ADD_REQUEST_TYPE'
export const WS_REMOVE_REQUEST_TYPE = 'WS_REMOVE_REQUEST_TYPE'
export const WS_GET_TERMINAL_DETAILS = 'GetTerminalDetails'

export const SET_USER_PDQ_TERMINALS = 'SET_USER_PDQ_TERMINALS'
export const PS_SET_TID = 'PS_SET_TID'
export const PS_SET_AVAILABLE_TIDS = 'PS_SET_AVAILABLE_TIDS'
export const PAYMENT = 'PAYMENT'
export const PAYMENT_REQUESTED = 'PAYMENT_REQUESTED'
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS'
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE'
export const WS_PS_SALE = 'WS_PS_SALE'
export const PS_SALE_REQUESTED = 'PS_SALE_REQUESTED'
export const PS_SALE_REQUEST_STATUS = 'PS_SALE_REQUEST_STATUS'

export const PS_METHOD_TERMINAL_NOTIFICATION = 'terminalNotification'

export const EMAIL = 'EMAIL'
export const EMAIL_SUCCESS = 'EMAIL_SUCCESS'
export const EMAIL_FAILURE = 'EMAIL_FAILURE'

export const REPORTS_LOGIN = 'REPORTS_LOGIN'
export const REPORTS_LOGIN_SUCCESS = 'REPORTS_LOGIN_SUCCESS'
export const REPORTS_LOGIN_FAILURE = 'REPORTS_LOGIN_FAILURE'

export const DECLINED_SIGNATURE_VERIFICATION_STATUS = 'DECLINED_SIGNATURE_VERIFICATION_STATUS'

export const REPORTS_REQUEST = 'REPORTS_REQUEST'
export const REPORTS_REQUEST_SUCCESS = 'REPORTS_REQUEST_SUCCESS'
export const REPORTS_REQUEST_FAILURE = 'REPORTS_REQUEST_FAILURE'

export const EODREPORTS_REQUEST = 'EODREPORTS_REQUEST'
export const EODREPORTS_REQUEST_SUCCESS = 'EODREPORTS_REQUEST_SUCCESS'
export const EODREPORTS_REQUEST_FAILURE = 'EODREPORTS_REQUEST_FAILURE'

export const DONATION_REQUEST_FAILED = 'DONATION_REQUEST_FAILED'

export const TERMINAL_NOTIFICATION_STATUS = 'TERMINAL_NOTIFICATION_STATUS'
export const PAGE_REDIRECT = 'PAGE_REDIRECT'

export const REPORTS_POPUP_SHOW = 'REPORTS_POPUP_SHOW'
export const REPORTS_POPUP_HIDE = 'REPORTS_POPUP_HIDE'

export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS'

export const LOAD_TRANSLATIONS_SUCCESS = 'LOAD_TRANSLATIONS_SUCCESS'
export const LOAD_TRANSLATIONS_FAILED = 'LOAD_TRANSLATIONS_FAILED'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js